import React from "react";
import { SectionTheme } from "./sections";

type SectionHeaderProps = {
  readonly theme: SectionTheme;
  readonly title: string;
  readonly prompt: string;
};

export default function SectionHeader({ theme, title, prompt }: SectionHeaderProps) {
  return (
    <div className={`screener-section-header screener-section-header--${theme}`}>
      <h2 className="screener-section-header__title">{title}</h2>
      <p className="screener-section-header__prompt">{prompt}</p>
    </div>
  );
}
